import PropTypes from 'prop-types'
import React from 'react'

export const AdCode = ({code}) => (
  <p>Šifra oglasa: {code}</p>
)

AdCode.propTypes = {
  code: PropTypes.string.isRequired
}
